// Central configuration for metros with canonical URLs and/or 301 redirects

// Default URL mappings for subpages - consistent across all metro sites
// Used for both canonical URLs and 301 redirects
const DEFAULT_SUBPAGE_MAPPINGS = {
    '/specials/': 'https://milanlaser.com/specials',
    '/lp/google/': 'https://milanlaser.com/lp/google',
    '/areas/bikini/': 'https://milanlaser.com/areas/bikini',
    '/areas/brazilian/': 'https://milanlaser.com/areas/brazilian',
    '/areas/darkskin/': 'https://milanlaser.com/inclusive-clientele/dark-skin',
    '/areas/for-men/': 'https://milanlaser.com/inclusive-clientele/for-men',
    '/areas/': 'https://milanlaser.com/areas',
    '/areas/legs/': 'https://milanlaser.com/areas/legs',
    '/areas/lipnchin/': 'https://milanlaser.com/areas/face/lip-and-chin',
    '/areas/underarm/': 'https://milanlaser.com/areas/underarm',
    '/lp/': 'https://milanlaser.com/lp',
    '/locations/about-us/': 'https://milanlaser.com/company/about-us',
    '/locations/contact/': 'https://milanlaser.com/company/contact-us',
    '/locations/': 'https://milanlaser.com/locations',
    '/locations/reviews/': 'https://milanlaser.com/company/reviews',
    '/process/compare/': 'https://milanlaser.com/process/compare',
    '/process/faqs/': 'https://milanlaser.com/process/faqs',
    '/process/': 'https://milanlaser.com/process',
    '/process/quiz/': 'https://milanlaser.com/process/quiz',
    '/specials/estimate/': 'https://milanlaser.com/specials/estimate',
    '/form/processing/': 'https://milanlaser.com/form/processing',
    '/form/self-success-force/': 'https://milanlaser.com/form/self-success-force',
    '/process/beforeafter/beforeafter_bikini/': 'https://milanlaser.com/process/beforeafter/beforeafter_bikini',
    '/process/beforeafter/beforeafter_legs/': 'https://milanlaser.com/process/beforeafter/beforeafter_legs',
    '/process/beforeafter/beforeafter_lip/': 'https://milanlaser.com/process/beforeafter/beforeafter_lip',
    '/process/beforeafter/beforeafter_men/': 'https://milanlaser.com/process/beforeafter/beforeafter_men',
    '/process/beforeafter/beforeafter_underarm/': 'https://milanlaser.com/process/beforeafter/beforeafter_underarm',
    '/process/beforeafter/': 'https://milanlaser.com/process/beforeafter',
};

// Metro configuration with feature flags
const METRO_CONFIGS = [
    {
        name: 'Atlanta',
        stateAbbrev: 'GA',
        targetPath: '/locations/ga/atlanta',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Boston',
        stateAbbrev: 'MA',
        targetPath: '/locations/ma/boston',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Chicago',
        stateAbbrev: 'IL',
        targetPath: '/locations/il/chicago',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Dallas',
        stateAbbrev: 'TX',
        targetPath: '/locations/tx/dallas',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Detroit',
        stateAbbrev: 'MI',
        targetPath: '/locations/mi/detroit',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Fort Myers',
        stateAbbrev: 'FL',
        targetPath: '/locations/fl/fort-myers',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Houston',
        stateAbbrev: 'TX',
        targetPath: '/locations/tx/houston',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Kansas City',
        stateAbbrev: 'MO',
        targetPath: '/locations/mo/kansas-city',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Las Vegas',
        stateAbbrev: 'NV',
        targetPath: '/locations/nv/las-vegas',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Manhattan',
        stateAbbrev: 'NY',
        targetPath: '/locations/ny/manhattan',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Miami',
        stateAbbrev: 'FL',
        targetPath: '/locations/fl/miami',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Minneapolis & St. Paul',
        stateAbbrev: 'MN',
        targetPath: '/locations/mn/minneapolis--st-paul',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Phoenix',
        stateAbbrev: 'AZ',
        targetPath: '/locations/az/phoenix',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Portland',
        stateAbbrev: 'OR',
        targetPath: '/locations/or/portland',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Quincy',
        stateAbbrev: 'IL',
        targetPath: '/locations/il/quincy',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Salt Lake City',
        stateAbbrev: 'UT',
        targetPath: '/locations/ut/salt-lake-city',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'San Antonio',
        stateAbbrev: 'TX',
        targetPath: '/locations/tx/san-antonio',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Tampa',
        stateAbbrev: 'FL',
        targetPath: '/locations/fl/tampa',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Vancouver',
        stateAbbrev: 'WA',
        targetPath: '/locations/wa/vancouver',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
    {
        name: 'Youngstown',
        stateAbbrev: 'OH',
        targetPath: '/locations/oh/youngstown',
        canonicalEnabled: true,
        redirectEnabled: true,
        subpageRedirectsEnabled: false,
    },
];

// Get metro configuration by name and state
function getMetroConfig(metroName, stateAbbrev) {
    return METRO_CONFIGS.find((metro) => metro.name === metroName && metro.stateAbbrev === stateAbbrev);
}

module.exports = {
    getMetroConfig,
    METRO_CONFIGS,
    DEFAULT_SUBPAGE_MAPPINGS,
};
